'use strict';

/* @preserve
 * https://github.com/Elkfox/Ajaxinate
 * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
 * MIT License (do not remove above copyright!)
 */
console.log("[Ajaxinate] loaded", "userScrollOnly supported =", true);

/* eslint-env browser */
function Ajaxinate(config) {
  var settings = config || {};

  var defaults = {
    method: 'scroll',
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    offset: 0,
    loadingText: 'Loading',
    callback: null,

    // ✅ When true, Ajaxinate will not load until a REAL user interaction occurs.
    // This prevents "Back to collection" restoring near pagination and auto-loading to footer.
    userScrollOnly: false
  };

  this.settings = Object.assign(defaults, settings);

  // State
  this.loading = false;
  this.userHasInteracted = false;

  // Bindings
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.preventMultipleClicks = this.preventMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.removePaginationElement = this.removePaginationElement.bind(this);
  this.destroy = this.destroy.bind(this);

  // ✅ handlers
  this.handleScroll = this.handleScroll.bind(this);
  this.handleViewportChange = this.handleViewportChange.bind(this);
  this.armOnUserGesture = this.armOnUserGesture.bind(this);
  this.handlePageShow = this.handlePageShow.bind(this);

  // Selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();

  // ✅ BFCache: when coming back, reset "armed" state so it doesn't auto-load
  window.addEventListener('pageshow', this.handlePageShow);
}

Ajaxinate.prototype.handlePageShow = function handlePageShow(e) {
  // BFCache restore
  if (e && e.persisted) {
    this.loading = false;

    // Force it to require a new user interaction after coming back
    if (this.settings.userScrollOnly) {
      this.userHasInteracted = false;
      this.installArmingListeners();
    }
  }
};

Ajaxinate.prototype.initialize = function initialize() {
  if (!this.containerElement) return;

  var initializers = {
    click: this.addClickListener,
    scroll: this.addScrollListeners
  };

  initializers[this.settings.method]();
};

Ajaxinate.prototype.installArmingListeners = function installArmingListeners() {
  // Only needed when userScrollOnly is enabled
  if (!this.settings.userScrollOnly) return;

  // Listen for any genuine interaction
  document.addEventListener('wheel', this.armOnUserGesture, { passive: true });
  document.addEventListener('touchstart', this.armOnUserGesture, { passive: true });
  document.addEventListener('touchmove', this.armOnUserGesture, { passive: true });
  document.addEventListener('keydown', this.armOnUserGesture);
  document.addEventListener('mousedown', this.armOnUserGesture);
};

Ajaxinate.prototype.removeArmingListeners = function removeArmingListeners() {
  document.removeEventListener('wheel', this.armOnUserGesture);
  document.removeEventListener('touchstart', this.armOnUserGesture);
  document.removeEventListener('touchmove', this.armOnUserGesture);
  document.removeEventListener('keydown', this.armOnUserGesture);
  document.removeEventListener('mousedown', this.armOnUserGesture);
};

Ajaxinate.prototype.armOnUserGesture = function armOnUserGesture(event) {
  if (event && event.isTrusted) {
    this.userHasInteracted = true;
    this.removeArmingListeners();
  }
};

Ajaxinate.prototype.addScrollListeners = function addScrollListeners() {
  if (!this.paginationElement) return;

  // ✅ Install arming listeners (must interact first)
  this.installArmingListeners();

  // ✅ Use handlers that respect gating
  document.addEventListener('scroll', this.handleScroll, { passive: true });
  window.addEventListener('resize', this.handleViewportChange);
  window.addEventListener('orientationchange', this.handleViewportChange);
};

Ajaxinate.prototype.handleScroll = function handleScroll() {
  this.checkIfPaginationInView();
};

Ajaxinate.prototype.handleViewportChange = function handleViewportChange() {
  // resize/orientation change can fire on back navigation → must respect gating
  this.checkIfPaginationInView();
};

Ajaxinate.prototype.addClickListener = function addClickListener() {
  if (!this.paginationElement) return;

  this.nextPageLinkElement = this.paginationElement.querySelector('a');
  this.clickActive = true;

  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.addEventListener('click', this.preventMultipleClicks);
  }
};

Ajaxinate.prototype.preventMultipleClicks = function preventMultipleClicks(event) {
  event.preventDefault();

  if (!this.clickActive || this.loading) return;

  this.nextPageLinkElement.innerText = this.settings.loadingText;
  this.nextPageUrl = this.nextPageLinkElement.href;
  this.clickActive = false;

  this.loadMore();
};

Ajaxinate.prototype.checkIfPaginationInView = function checkIfPaginationInView() {
  if (!this.paginationElement || this.loading) return;

  // ✅ CRITICAL: Gate here (so nothing can bypass it)
if (this.settings.userScrollOnly && !this.userHasInteracted) {
  console.log("[Ajaxinate] BLOCKED - no user interaction yet");
  return;
}

  var rect = this.paginationElement.getBoundingClientRect();
  var top = rect.top - this.settings.offset;
  var bottom = rect.bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      console.log("[Ajaxinate] LOADING NEXT PAGE", this.nextPageUrl);
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function loadMore() {
  if (this.loading) return;
  this.loading = true;

  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function success() {
    if (this.request.readyState !== 4) return;

    this.loading = false;

    if (this.request.status !== 200 || !this.request.responseXML) {
      this.initialize();
      return;
    }

    var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
    var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

    if (!newContainer) {
      this.removePaginationElement();
      return;
    }

    this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);

    if (!newPagination) {
      this.removePaginationElement();
    } else {
      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }

      this.initialize();
    }
  }.bind(this);

  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickListener() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener('click', this.preventMultipleClicks);
  }
};

Ajaxinate.prototype.removePaginationElement = function removePaginationElement() {
  if (this.paginationElement) {
    this.paginationElement.innerHTML = '';
  }
  this.destroy();
};

Ajaxinate.prototype.removeScrollListener = function removeScrollListener() {
  document.removeEventListener('scroll', this.handleScroll);
  window.removeEventListener('resize', this.handleViewportChange);
  window.removeEventListener('orientationchange', this.handleViewportChange);

  // also remove arming listeners (cleanup)
  this.removeArmingListeners();
};

Ajaxinate.prototype.destroy = function destroy() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };

  destroyers[this.settings.method]();

  // cleanup pageshow listener
  window.removeEventListener('pageshow', this.handlePageShow);

  return this;
};

// Expose globally
window.Ajaxinate = Ajaxinate;